import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface TransactionCode {
  _id: string;
  studioId?: string;
  code: string;
  description: string;
  sessionId: string | null;
  sessionName: string | null;
  entities: Array<Entity>;
  isDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface Entity {
  entityId: string;
  entityName: string;
  _id: string;
}

export const getTransactionCode = async () => {
  const response =
    await baseAPI.get<Array<TransactionCode>>(`transaction-code`);
  return response.data;
};

export const useGetTransactionCode = () => {
  return useQuery({
    queryKey: [KEYS.TRANSACTION_CODE],
    queryFn: () => getTransactionCode(),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
